(function()
{
	//Import classes
	var BaseState = include('springroll.easeljs.BaseState'),
		SuccessPanel = include('WGBH.SuccessPanel'),
		Quack = include('WGBH.Quack');

	/**
	 * The logic for the title state
	 * @class WGBH.SuccessState
	 * @extends springroll.easeljs.BaseState
	 */
	var SuccessState = function(options)
	{
		BaseState.call(this, new SuccessPanel(), options);
		
		this.playSuccessAudio = this.playSuccessAudio.bind(this);
		this.successAudioDone = this.successAudioDone.bind(this);
		this.onPlay = this.onPlay.bind(this);
	};

	// Extend the base class
	var p = extend(SuccessState, BaseState);

	/**
	 * After assets are loaded and state is fully entered
	 * @method  enterDone
	 */
	p.enterDone = function()
	{
		app.acc_mgr.setCaptionParameters('captions', app.config.GAME.CAPTIONS.success);

		// parameters
		this.success_type = '';
		
		// set up display
		this.animdisp = this.panel.animdisp;
        this.uidisp = this.panel.uidisp;  
		
		// add quack character
		this.quack = new Quack();
		this.animdisp.addChild(this.quack.view);
		
		// create buttons
		this.captbt = new AccButtonToggle(
						'captbt',
        				LOADED_OBJECTS.sprsheets.graphics_spr,
        				app.config.GAME.BUTTONS.captbt.x,
        				app.config.GAME.BUTTONS.captbt.y, 
        				app.config.GAME.BUTTONS.captbt.wid, 
        				app.config.GAME.BUTTONS.captbt.hgt,
        				app.config.GAME.BUTTONS.captbt.label,
        				app.capt_on 
        				);
		app.acc_mgr.addInteractiveButton(this.captbt);
		this.captbt.ev_disp.on('BUTTON_DOWN', this.buttonActivation);
		this.uidisp.addChild(this.captbt.view);
		
		// set status of captions
		if(app.capt_on) {
			this.buttonActivation({'id':'captbt_on'});
		}
		else {
			this.buttonActivation({'id':'captbt_off'});
		}

		this.musicbt = new AccButtonToggle(
						'musicbt',
        				LOADED_OBJECTS.sprsheets.graphics_spr,
        				app.config.GAME.BUTTONS.musicbt.x,
        				app.config.GAME.BUTTONS.musicbt.y, 
        				app.config.GAME.BUTTONS.musicbt.wid, 
        				app.config.GAME.BUTTONS.musicbt.hgt,
        				app.config.GAME.BUTTONS.musicbt.label,
        				app.bg_music_on 
        				);
		app.acc_mgr.addInteractiveButton(this.musicbt);
		this.musicbt.ev_disp.on('BUTTON_DOWN', this.buttonActivation);
        this.uidisp.addChild(this.musicbt.view);
        		
		// put in delay 
		this.delay_timer = new springroll.DelayedCall(this.playSuccessAudio, 800, {repeat:false});
	};
	
	// used to react to button clicks
	p.buttonActivation = function(ev) {
//console.log('BUTTON ACTIVATED: ' + ev.id);
		switch(ev.id) {
		case 'musicbt_on':
			app.playBackgroundMusic();
			break;
		case 'musicbt_off':
			app.stopBackgroundMusic();
			break;		
		case 'captbt_on':	
			app.caption_disp.className = 'on';
			app.capt_on = true;		
            window.parent.postMessage('captions on', '*');			
			break;
		case 'captbt_off':
			app.caption_disp.className = 'off';
			app.capt_on = false;		
            window.parent.postMessage('captions off', '*');		
			break;		
		}	
	};
	
	// used to play success audio
	p.playSuccessAudio = function() {
		if(app.success_resp.length === 0) {
			app.success_resp = app.config.GAME.RESPONSES.success.slice(0);
		}
		this.success_type = app.success_resp.shift();
		app.voPlayer.play(this.success_type, this.successAudioDone);		
		this.quack.view.gotoAndPlay('speak_' + this.success_type);
	};
	
	// used to trigger replay audio
	p.successAudioDone = function() {
		app.voPlayer.play(['pause', 'playagain', 'pause'], this.onPlay);		
	};

	/**
	 * Handler when the play button is clicked
	 * @method  onPlay
	 * @private
	 */
	p.onPlay = function()
	{
		app.voPlayer.stop();
		this.nextState();
	};

	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		app.acc_mgr.removeButtonsFromDOM();	
		app.acc_mgr.clearSRContent();	
		// remove things from the display
		while(this.uidisp.numChildren > 0) {
			this.uidisp.removeChildAt(0);
		}
		this.musicbt.clearObject();
		this.captbt.clearObject();
		this.quack.clearObject();
	};

	//Assign to namespace
	namespace("WGBH").SuccessState = SuccessState;
}());
